
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/schedule-at-a-glance",
      function () {
        return require("private-next-pages/world/schedule-at-a-glance.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/schedule-at-a-glance"])
      });
    }
  